export default {
    auditStatus: ['待审核', '审核通过', '审核未通过'],
    stage: ['待开始', '已开始', '已结束', '已取消'],
    onlineConference: '在线会议',
    myFound: '我创建的',
    mySubscribe: '我预约的',
    shareType: ['直接加入', '扫一扫加入', '输入房间号加入', 'H5链接加入'],
    realPersonTabs: ['全部', '未响应', '已同意', '已拒绝', '参会申请列表'],
    'Customer Pool': '客户池',
    'Enterprise Staff': '企业员工',
    'accepted': ['未响应', '已接受', '已拒绝']
}